/**
 * Find the first entry in an object by a predicate of the values in the object
 */
export default function objectFind<T>(obj: { [key: string]: T }, pred: (v: T) => boolean): T | undefined {
  if (!obj) {
    return undefined;
  }

  for (const key in obj) {
    if (!pred(obj[key])) {
      continue;
    }
    return obj[key];
  }

  return undefined;
}
